import React, { useEffect, useState } from "react";
import { Button, Dropdown, Menu, Input, Tooltip, message } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useSaleSoModel } from "../saleSoModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useSaleSoDetailModel } from "./details/saleSoDetailModel";
import { DownOutlined } from "@ant-design/icons";
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";
import { truncate } from "fs";
import { saleSoService } from "../saleSoService";
import { PrintTable } from "./PrintTable";

export const DataBox = () => {
    const {
        selectedRowKeys,
        selectedRow,
        descTotal,
        rowsDescTotal,
        invalidate,
        descRows,
        exportSaleSo,
        setPrint,
        detailsExport,
        setSelectedRowKeys,
        setSettleScaniaPrint,
        setConfirmModal,
    } = useSaleSoModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const [printVisible, setPrintVisible] = useState<boolean>(false);
    const { resetEditCatch } = useSaleSoDetailModel()
    const { shopAndOrg: { shopCode }, user } = useGlobalModel()
    const desc: IDescription[] = [
        {
            label: "销售数量",
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum,// "1232",
            color: DescriptionColorEnum.red
        },
        {
            label: "销售金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount),// "￥33.23",
            color: DescriptionColorEnum.red
        },
        {
            label: "优惠总金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.discountTotalAmount : rowsDescTotal.discountTotalAmount),// "￥1232",
            color: DescriptionColorEnum.red
        },
        {
            label: "营业额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.receivedAmount : rowsDescTotal.receivedAmount),// "￥1232",
            color: DescriptionColorEnum.red
        },
        {
            label: "已收金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.receivableAmount : rowsDescTotal.receivableAmount),// "￥1232",
            color: DescriptionColorEnum.red
        },
        {
            label: "销售成本",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.latestPurPrice : rowsDescTotal.latestPurPrice),// "￥1232",
            color: DescriptionColorEnum.red
        },
        {
            label: "销售毛利",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.grossProfit : rowsDescTotal.grossProfit),// "￥1232",
            color: DescriptionColorEnum.red
        },
    ]

    const onEdit = () => {
        console.log("aaaaaaaaaa")
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        // if (selectedRow.status === "sale.stock-io") {
        //     globalPrompt("message", { text: "该单据已出库，无法进行编辑", type: "warning" });
        //     return;
        // }
        if (selectedRow.status === "sale.change") {
            globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            return;
        }
        let saleSoEditKey = "5-2-2";
        let isFindNav = findNav(saleSoEditKey);
        if (!isFindNav) {
            addNav(saleSoEditKey, { id: selectedRow?.saleCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "销售单跳转详情",
                type: "warning",
                text: "您还有销售单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(saleSoEditKey, { id: selectedRow?.saleCode as string, mode: "edit" });
                    // updateEditFormVal(null);
                    resetEditCatch()
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "5-2-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow?.saleCode as string, mode: "look", },
            true
        );
    }

    const onPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrint(true)
    }
    const onPurPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrintVisible(true)
    }
    const onSupplement = () => {
        addNav("5-2-1", {
            id: "", mode: "add", parentInfo: {
                Supplement: "Supplement"
            }
        })
    }
    const exportMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={() => exportSaleSo()}>列表导出</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={() => detailsExport()}>详情导出</span>
                </Menu.Item>
            </Menu>
        )
    }
    const onSettleSknyPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setSettleScaniaPrint(true)
    }
    const cancellation = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let cancelReason: string = ""
        globalPrompt("modal", {
            title: "销售单作废",
            type: "error",
            text: <><span>请输入作废原因</span>
                <Input onChange={(e) => { cancelReason = e.target.value }} /></>,
            okText: "确定",
            onOk: () => {
                invalidate(cancelReason)
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const someSettle = () => {
        if (selectedRowKeys.length == 0) {
            globalPrompt("message", { text: "请选择数据进行出库！", type: "warning" });
            return;
        }
        if (descRows.find((item) => item.status !== "sale.settle")) {
            globalPrompt("message", { text: "请选择已结算数据进行出库！", type: "warning" });
            return;
        }
        // globalPrompt("modal", {
        //     title: "出库",
        //     type: "warning",
        //     okText: "确定",
        //     text: "您是否将所选数据进行出库！",
        //     onOk: async () => {
        //         let params:any=[]
        //         descRows.map((item)=>{
        //             params.push({
        //                 id:item.id,
        //                 saleCode:item.saleCode,
        //                 storekeeper:user.username,
        //             })
        //         })
        //         let { retData } = await saleSoService.someSettle(params);
        //         if(retData){
        //         message.success('出库成功')
        //     }
        //     },
        //     cancelText: "取消",
        //     onCancel: () => {
        //     }
        // })
        setConfirmModal(true);

    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.S_S_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav("5-2-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_S_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_S_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_S_EX}>
            <Dropdown overlay={exportMenu}>
                {/* <Tooltip placement="topLeft" title={disableExportMsg}> */}
                <Button
                    // disabled={true}
                    className="mr-5"
                    type="primary"
                    shape="round"
                >导出<DownOutlined /></Button>
                {/* </Tooltip> */}
            </Dropdown>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_S_PRINT}>
            {/* <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => exportSaleSo().then()}
        >导出</Button> */}
            {shopCode === "SHOP-M-00000020" ||
                shopCode === "SHOP-M-00000019" ||
                shopCode === "SHOP-M-00000021" ?
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={selectedRowKeys.length > 1}
                    onClick={onSettleSknyPrint}
                >结算打印</Button> :
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={selectedRowKeys.length > 1}
                    onClick={onPrint}
                >打印</Button>
            }
        </YhAuth>
        {/* <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onPrint}
            disabled={selectedRowKeys.length >1}
        >财务打印</Button> */}
        <YhAuth resCode={ResourceAuthEnum.S_S_CANCEL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={cancellation}
            >作废</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.S_S_REPL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onSupplement}
            >补单</Button>
        </YhAuth> */}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => {
                if (descRows.find((item) => !((item.status == "sale.settle" && (item.payType == 'settle-type.monthly' || item.payType == 'settle-type.credit')) || (item.status == "sale.settle" && item.payType == 'settle-type.cash' && item.payStatus == 'pay-status.write-off')))) {
                    message.warning("信息筛选有误，此状态下不可操作该功能！");
                    return;
                }
                someSettle()
            }}
        >{selectedRowKeys.length > 1 ? '批量出库' : '出库'}</Button>
        <YhAuth resCode={ResourceAuthEnum.S_S_ZCPRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPurPrint()}
            >直采出库打印</Button>
        </YhAuth>
    </>;

    return (
        // <YhBox title={"销售单列表"} descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}>
        <>
            <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
                <DataTable />
            </YhBox>
            <PrintTable printVisible={printVisible} setPrintVisible={setPrintVisible} />
        </>
    )
}